import { INamespaceActionCreator, IReducer } from '@omaze/redux';
import { RefObject, FC } from 'react';
import { AnyAction } from 'redux';

import { TOOLTIP_ACTIONS } from '../../Tooltip.actions';
import { createTooltipActionCreatorFactory, createTooltipReducerFactory } from '../../Tooltip.factories';
import { ITooltipMessage, ITooltipState } from '../../Tooltip.state';

export const createTooltipAddAction: INamespaceActionCreator = createTooltipActionCreatorFactory(
    TOOLTIP_ACTIONS.ADD,
    (tooltipMessage: FC, ref: RefObject<HTMLElement>): ITooltipMessage => {
        return {
            messageComponent: tooltipMessage,
            ref: {
                topBound: ref.current?.getBoundingClientRect().top,
                leftBound: ref.current?.getBoundingClientRect().left,
                offsetHeight: ref.current?.offsetHeight,
            },
        };
    });

export const createTooltipAddReducer: IReducer<ITooltipState> = createTooltipReducerFactory(
    TOOLTIP_ACTIONS.ADD,
    (state: ITooltipState, action: AnyAction): void => {
        state.message = {
            messageComponent: action.payload.messageComponent,
            ref: action.payload.ref,
        };
    },
);
